import { GTag } from './GTag';
import {
  AppDataSync,
  InstancesStore,
} from '../Analytics/context/AnalyticsContext.types';

export const getGtagInstances = (appDataSync: AppDataSync) => {
  const gtag = appDataSync?.gtag;
  const gtagInstances: InstancesStore = {};
  const defaultInstanceName = 'DEFAULT_GTAG_INSTANCE';

  if (gtag?.default) {
    const defaultInstance = new GTag();
    gtagInstances[defaultInstanceName] = {
      mode: 'gtag',
      instance: defaultInstance,
    };
  }

  if (gtag?.configs) {
    gtag.configs.forEach(config => {
      if (!gtagInstances[config.name]) {
        const customInstance = new GTag(config.measurementId);

        gtagInstances[config.name] = {
          mode: 'gtag',
          instance: customInstance,
        };
      }
    });
  }

  return gtagInstances;
};
